const appWidth = 1000;
const appHeight = 680;
const loginWidth = 400;
const loginHeight = 600;

export interface NotifyEvent<T = unknown> {
  api: string;
  data: T;
}

export function mouseDown(x: number, y: number) {
  window.LinkService?.request("/api/main/v1/window/mouseDown", { x, y });
}

export function move(x: number, y: number) {
  window.LinkService?.request("/api/main/v1/window/move", { x, y });
}

export function mouseUp(x: number, y: number) {
  window.LinkService?.request("/api/main/v1/window/mouseUp", { x, y });
}

export function getFullScreen() {
  return window.LinkService?.request("/api/main/v1/window/getFullScreenStatus", {});
}

export function getMaximizedStatus() {
  return window.LinkService?.request("/api/main/v1/window/getMaximizedStatus", {});
}

export function setFullScreen(status: boolean) {
  return window.LinkService?.request("/api/main/v1/window/setFullScreen", { status });
}

export function setMaxsize(status: boolean) {
  return window.LinkService?.request("/api/main/v1/window/setMaxsize", { status });
}

export function subscribeFullScreenStatus(cb: (data: NotifyEvent<boolean>) => void) {
  return window.LinkService?.subscribe<NotifyEvent<boolean>>("/sub/main/v1/window/fullScreenStatus", cb);
}

export function subscribeMaxsizeStatus(cb: (data: NotifyEvent<boolean>) => void) {
  return window.LinkService?.subscribe<NotifyEvent<boolean>>("/sub/main/v1/window/maximizeStatus", cb);
}

export function subscribeUpgrateWindowFocusStatus(cb: (data: NotifyEvent<boolean>) => void) {
  return window.LinkService?.subscribe<NotifyEvent<boolean>>("/sub/main/v1/window/upgradeWindowFocusStatus", cb);
}

export function setMainSize(needCenter = true) {
  return window.LinkService?.request("/api/main/v1/window/setSize", {
    appWidth,
    appHeight,
    minWidth: appWidth,
    minHeight: appHeight,
    designWidth: 1440,
    designHeight: 900,
    needCenter,
    resizable: true,
    fullScreenable: true,
  });
}

export async function setLoginSize() {
  try {
    await setFullScreen(false);
  } catch (e) {
    console.log("setFullScreen error", e);
  }
  try {
    await setMaxsize(false);
  } catch (e) {
    console.log("setMaxsize error", e);
  }
  return window.LinkService?.request("/api/main/v1/window/setSize", {
    appWidth: loginWidth,
    appHeight: loginHeight,
    minWidth: loginWidth,
    minHeight: loginHeight,
    designWidth: 1440,
    designHeight: 900,
    resizable: false,
    fullScreenable: false,
  });
}

export function setMainSizeFromAiQA() {
  return window.LinkService?.request("/api/main/v1/window/setSize", {
    appWidth: window.innerWidth - 320,
    appHeight: window.innerHeight,
    minWidth: appWidth,
    minHeight: appHeight,
    designWidth: 1440,
    designHeight: 900,
    needCenter: false,
    resizable: true,
    fullScreenable: true,
  });
}

export function setAIQASize() {
  const appWidth = window.innerWidth + 320;
  const appHeight = window.innerHeight;
  const minWidth = 1320;
  const minHeight = 680;
  return window.LinkService?.request("/api/main/v1/window/setSize", {
    appWidth,
    appHeight,
    minWidth,
    minHeight,
    designWidth: 1440,
    designHeight: 900,
    needCenter: false,
    resizable: true,
    fullScreenable: true,
  });
}

export function setHide() {
  window.LinkService?.request("/api/main/v1/window/hide", {});
}

export function setClose() {
  window.LinkService?.request("/api/main/v1/window/close", {});
}

let ratio: null | number = null;
export async function getRatio() {
  if (ratio === null) {
    const res = await window.LinkService?.request("/api/main/v1/window/getZoomratio", {});
    ratio = res.data;
  }
  return ratio;
}

export async function getClientVersion() {
  try {
    const res = await window.LinkService?.request("/api/main/v1/upgrate/getVersion", {});
    return res.data;
  } catch (e) {
    return "";
  }
}

export async function checkUpgrate() {
  const res = await window.LinkService?.request("/api/main/v1/upgrate/checkUpgrate", {});
  return res ? res.data : false;
}

export function subscribeHasUpgrateStatus(cb: (data: NotifyEvent<boolean>) => void) {
  return window.LinkService?.subscribe<NotifyEvent<boolean>>("/sub/main/v1/upgrate/hasUpgrateStatus", cb);
}

export function subscribeUpgrateStatus (cb: (data: any) => void) {
  return window.LinkService?.subscribe("/sub/main/v1/upgrate/upgrateStatus", cb);
}

export async function openUpgrateWindow() {
  window.LinkService?.request("/api/main/v1/upgrate/openUpgrateWindow", {});
}

export async function openAboutWindow() {
  window.LinkService?.request("/api/main/v1/upgrate/openAboutWindow", {});
}

export async function openFeedbackWindow(info: { mobile: string; userId: string }) {
  window.LinkService?.request("/api/main/v1/feedback/openFeedbackWindow", info);
}

export async function subscribeUseAIMic(cb: (data: NotifyEvent<{starttype: string; startdevice: string; starttimestamp: number;}>) => void) {
  return window.LinkService?.subscribe<NotifyEvent<{starttype: string; startdevice: string;}>>("/sub/main/v1/window/useAIMic", cb);
}
